// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/bg_slide.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./img/converter.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/img/products/genorocity_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/img/products/nft_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/img/products/axepay_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/img/products/profiler_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../src/img/products/mtickets_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../src/img/products/articul_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../src/img/products/eschool_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../src/img/products/doc_div_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../src/img/products/abotslife_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../src/img/products/ijobs_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../src/img/products/distributer_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../src/img/products/originatorx_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../src/img/products/guru_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../src/img/products/continue2eat_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../src/img/products/games_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../src/img/products/atelier_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../src/img/products/phaces_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../src/img/products/redeembank_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../src/img/products/metarealm_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../src/img/products/onroute_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../src/img/products/mytravel_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../src/img/products/check21saas_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../src/img/products/menu.event.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../src/img/products/flexiibility.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../src/img/products/emphasispay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./img/product.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./img/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&family=Sora:wght@100..800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
		'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
		sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	overflow-x: hidden;
}

code {
	font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
		monospace;
}

.blk-menu {
	padding: 5px 2px;
	background-color: black;
	padding-left: 6%;
	padding-right: 6%;
}

.blk-menu ul {
	padding: 0px;
	list-style: none;
	margin-top: 23px;
}

.menu {
	padding: 0px;
	list-style: none;
	float: right;
	margin-top: 3%;
}

.menu li {
	float: left;
}

.menu li a {
	text-decoration: none;
	padding: 10px;
	color: #fff;
}

.border-right1 {
	border-right: 1px solid #ffc107;
}

.yellow-text {
	color: #ffc107 !important;
}

.bg-nav {
	background-color: #ffa800;
}

.bg-nav ul li a {
	/* padding: 20px; */
	color: white;
	font-weight: 500;
	text-decoration: none;
}

.bg-nav ul li {
	padding: 20px;
}

.slide {
	height: 500px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-size: cover;
}

.slick-slider {
	-webkit-touch-callout: none;
	touch-action: pan-y;
	-webkit-user-select: none;
	user-select: none;
	-khtml-user-select: none;
	margin: 30px auto 50px;
}

.slick-next:before,
.slick-prev:before {
	color: #fff !important;
	font-size: 32px !important;
	line-height: 1;
	opacity: .75 !important;
	color: #ffa800 !important;
}

.slick-prev {
	left: 11px !important;
	z-index: 99999999999999999999999999999999;
}

.slick-next {
	right: 11px !important;
	z-index: 99999999999999999999999999999999;
}

.slick-prev,
.slick-next {
	font-size: 0;
	line-height: 0;
	position: absolute;
	top: 50%;
	display: block;
	width: 20px;
	height: 20px;
	padding: 0;
	transform: translate(0, -50%);
	cursor: pointer;
	color: transparent;
	border: none;
	outline: none;
	background: transparent;
}

.slick-slider {
	margin: 0px !important;
}

.center {
	margin: auto;
	text-align: center;
	top: 25%;
	position: relative;
	width: 50%;
	background: #00000061;
	padding: 30px;
}

.bg-yellow {
	background: #ffc107 !important;
}

.intro_image {
	max-width: 100%;
	/* height: 394px; */
	margin-right: 10px;
}

.intro {
	padding-top: 110px;
	padding-bottom: 110px;
	background: #f5f9fa;
}

@media (min-width:641px) {

	/* portrait tablets, portrait iPad, e-readers (Nook/Kindle), landscape 800x480 phones (Android) */
	.bg-nav ul li {
		padding: 17px;
	}

	.min-box img,
	.genoro-box img {
		width: 80%;
	}

	.genoro-box img {
		height: auto !important;
	}

	.min-box {
		font-size: 10px;
	}

	.granular-img {
		width: 100%;
	}

	.pos span {
		padding: 2px 3px !important;
		margin: 2px 3px !important;
	}
}

.right-box {
	height: auto;
}


.intro_image img {
	max-width: 100%;
}

.intro_title {
	font-family: 'gill', sans-serif;
	color: #212121;
	margin-top: -1px;
}

.intro_subtitle {
	font-family: 'gill', sans-serif;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: 0.2em;
	color: #a5a5a5;
	padding-left: 6px;
	padding-top: 30px;
}

.intro_subtitle::after {
	display: block;
	position: absolute;
	top: 0;
	left: 5px;
	width: 68px;
	height: 3px;
	background: #ffa800;
	content: '';
}

.intro_text {
	margin-top: 32px;
}

.intro_text p:last-of-type {
	margin-bottom: 0;
}

.intro_button {
	margin-top: 39px;
}

.home_slider_container {
	width: 100%;
	height: 100%;
}

.home_slider {
	width: 100%;
	height: 100%;
}

.slider_background {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
}

.home_slider .owl-dots {
	position: absolute;
	bottom: 29px;
	left: 50%;
	transform: translateX(-50%);
}

.home_slider .owl-dots .owl-dot span {
	width: 8px;
	height: 8px;
	background: #d2d2d2;
	margin-top: 5px;
	margin-right: 6px;
	margin-bottom: 5px;
	margin-left: 6px;
}

.home_slider .owl-dots .owl-dot.active span {
	background: #bda994;
}

.home_slider_content {
	position: absolute;
	top: 35%;
	left: 50%;
	transform: translateX(-50%);
	width: 776px;
	padding-left: 25px;
	padding-right: 25px;
	padding-top: 74px;
	padding-bottom: 55px;
	background: rgba(17, 16, 14, 0.83);
}

.home_slider_content h1 {
	font-family: 'gill', sans-serif;
	font-size: 72px;
	line-height: 1.1;
	color: #FFFFFF;
}

.home_slider_text {
	width: 72%;
	margin: 0 auto;
	margin-top: 15px;
	font-family: 'gill', sans-serif;
	font-size: 18px;
	color: #FFFFFF;
}

.link_button {
	width: 174px;
	height: 59px;
	background: #ffa800;
	text-align: center;
}

.link_button a {
	display: block;
	position: relative;
	line-height: 59px;
	font-family: 'gill', sans-serif;
	font-size: 14px;
	font-weight: bold;
	color: #FFFFFF;
	text-transform: uppercase;
	z-index: 1;
	transition: all 300ms ease;
}

.home_slider_button {
	margin: 0 auto;
	margin-top: 30px;
}

.link_button a::after {
	display: block;
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 50%;
	height: 100%;
	background: #FFFFFF;
	content: '';
	opacity: 0;
	transition: all 300ms ease;
	z-index: -1;
}

.link_button:hover a::after {
	width: 100%;
	opacity: 1;
}

.link_button:hover a {
	color: #ffa800;
}

.home_slider_nav {
	position: absolute;
	top: 56.32%;
	width: 46px;
	height: 46px;
	border-radius: 50%;
	background: #939393;
	cursor: pointer;
	transition: all 200ms ease;
	z-index: 10;
}

.home_slider_prev {
	left: 177px;
}

.home_slider_next {
	right: 177px;
}

.home_slider_nav:hover {
	background: #ffa800;
}

/*********************************
8. Converter
*********************************/

.converter {
	padding-top: 130px;
	padding-bottom: 138px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.converter_background {
	/* position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%; */
}

.converter_title {
	font-family: 'gill', sans-serif;
	color: #FFFFFF;
	margin-top: -1px;
}

.converter_subtitle {
	font-family: 'gill', sans-serif;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: 0.2em;
	color: #a5a5a5;
	padding-left: 2px;
	padding-top: 30px;
}

.converter_subtitle::after {
	display: block;
	position: absolute;
	top: 0;
	left: 5px;
	width: 68px;
	height: 3px;
	background: #ffa800;
	content: '';
}

.converter_text {
	margin-top: 32px;
}

.converter_text p {
	color: #FFFFFF;
}

.converter_text p:last-of-type {
	margin-bottom: 0;
}

.converter_container {
	padding-top: 182px;
}

.converter_container form:last-of-type {
	margin-top: 19px;
}

.converter_input {
	display: inline-block;
	width: 84px;
	height: 52px;
	background: transparent;
	color: #FFFFFF;
	text-align: center;
	font-size: 18px;
	font-weight: 600;
	outline: none;
	vertical-align: top;
	margin-right: 10px;
}

.converter_input_value {
	border: solid 2px #ffa800;
}

.dropdown_converter {
	display: inline-block;
	-o-appearance: none;
	appearance: none;
	-webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
	-webkit-user-select: none;
	width: 134px;
	/* background-image: url(../images/dropdown.png); */
	background-position: center right;
	background-repeat: no-repeat;
	border: solid 2px #c6b5b7;
	padding-left: 20px;
	text-transform: uppercase;
	vertical-align: top;
	cursor: pointer;
}

.dropdown_converter:hover {
	border: solid 2px #ffa800;
}

.converter_result {
	border: solid 2px #c6b5b7;
	width: 116px;
}

.dropdown_converter option {
	color: #11100e;
}

.converter_input::-webkit-input-placeholder {
	font-size: 18px !important;
	font-weight: 600 !important;
	color: #FFFFFF !important;
}

.converter_input:-moz-placeholder {
	font-size: 18px !important;
	font-weight: 600 !important;
	color: #FFFFFF !important;
}

.converter_input::-moz-placeholder {
	font-size: 18px !important;
	font-weight: 600 !important;
	color: #FFFFFF !important;
}

.converter_input:-ms-input-placeholder {
	font-size: 18px !important;
	font-weight: 600 !important;
	color: #FFFFFF !important;
}

.converter_input::input-placeholder {
	font-size: 18px !important;
	font-weight: 600 !important;
	color: #FFFFFF !important;
}

.eq {
	display: inline-block;
	width: 95px;
	height: 52px;
	vertical-align: top;
	line-height: 48px;
	font-size: 30px;
	font-weight: 600;
	color: #FFFFFF;
	text-align: center;
	margin-right: 10px;
}

.bg-black1 {
	/* background: black;
	padding: 10px; */

}

.footer1 h3 {
	font-size: 16px;
	color: white;
}

/*********************************
11. Footer
*********************************/

.footer {
	padding-top: 20px;
	background: #15191f;
}

.footer_logo {
	position: absolute;
	top: -18px;
	left: 0px;
}

.footer_about_text {
	color: #c2cbd7;
	line-height: 2.14;
	padding-top: 86px;
}

.footer_about p:last-of-type {
	margin-bottom: 0;
}

.footer_title {
	font-family: 'gill', sans-serif;
	font-size: 24px;
	color: #FFFFFF;
}

.footer_links ul {
	columns: 2;
	-webkit-columns: 2;
	-moz-columns: 2;
	margin-top: 53px;
}

.footer_links ul li {
	margin-bottom: 9px;
}

.footer_links ul li a {
	font-size: 14px;
	color: #c2cbd7;
	transition: all 200ms ease;
}

.footer_links ul li a:hover {
	color: #ffa800;
}

.footer_newsletter_form {
	display: block;
	position: relative;
	margin-top: 20px;
}

.footer_newsletter_input {
	width: 100%;
	height: 47px;
	background: transparent;
	border: solid 2px rgba(224, 227, 228, 0.17);
	padding-left: 26px;
	outline: none;
	color: #ffa800;
	transition: all 200ms ease;
}

.footer_newsletter_input:focus {
	border: solid 2px rgba(224, 227, 228, 0.34);
}

.footer_newsletter_button {
	position: absolute;
	top: 0;
	right: 0;
	width: 127px;
	height: 47px;
	background: #ffa800;
	border: none;
	outline: none;
	font-size: 14px;
	text-transform: uppercase;
	color: #FFFFFF;
	font-weight: 600;
	cursor: pointer;
}

.footer_newsletter_input::-webkit-input-placeholder {
	font-size: 11px !important;
	font-style: italic;
	color: #c2cbd7 !important;
}

.footer_newsletter_input:-moz-placeholder {
	font-size: 11px !important;
	font-style: italic;
	color: #c2cbd7 !important;
}

.footer_newsletter_input::-moz-placeholder {
	font-size: 11px !important;
	font-style: italic;
	color: #c2cbd7 !important;
}

.footer_newsletter_input:-ms-input-placeholder {
	font-size: 11px !important;
	font-style: italic;
	color: #c2cbd7 !important;
}

.footer_newsletter_input::input-placeholder {
	font-size: 11px !important;
	font-style: italic;
	color: #c2cbd7 !important;
}

.footer_newsletter_text {
	font-size: 11px;
	line-height: 2.18;
	color: #c2cbd7;
	font-style: italic;
	margin-top: 19px;
	padding-left: 3px;
}

.footer_social {
	margin-top: 33px;
}

.footer_social ul li {
	display: inline-block;
	margin-right: 10px;
}

.footer_social ul li a i {
	color: #FFFFFF;
	font-size: 17px;
	padding: 5px;
	transition: all 200ms ease;
}

.footer_social ul li:hover a i {
	color: #ffa800;
}

.copyright {
	width: 100%;
	margin-top: 110px;
	background: #0d1016;
}

.copyright_content {
	width: 100%;
	height: 70px;
}

.footer_nav {
	width: 100%;
	height: 70px;
	text-align: right;
}

.footer_nav ul li {
	display: inline-block;
	margin-right: 23px;
}

.footer_nav ul li:last-child {
	margin-right: 0;
}

.footer_nav ul li a {
	font-family: 'gill', sans-serif;
	font-size: 13px;
	color: #697686;
	transition: all 200ms ease;
}

.footer_nav ul li a:hover {
	color: #ffa800;
}

.cr {
	font-family: 'gill', sans-serif;
	font-size: 13px;
	color: #697686;
}

.footer1 ul {
	list-style: none;
	padding: 0px;
	margin: 0px;
}

.footer1 ul li a,
.footer1 a {
	text-decoration: none;
	color: #ffa800;
}

.social-menu li {
	float: left;
}

.social-menu li a {
	padding: 5px;
}

.social-menu li a svg {
	font-size: 24px;
}

.mission img {
	height: 200px;
}

.msh1 {
	font-family: "Poppins", serif;
	font-weight: 400;
	font-style: normal;
}

.text1 {
	font-family: "Raleway", serif;
	font-optical-sizing: auto;
	/* font-weight: <weight>; */
	font-style: normal;
	text-align: justify;
}

.bg-about {
	padding-bottom: 10px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.about-a h2 {
	font-family: "Rubik", serif;
	font-optical-sizing: auto;
	/* font-weight: <weight>; */
	font-style: normal;
	font-size: 50px;
}

.h2-f {
	font-size: 25px;
	font-family: "Poppins", serif;
	font-weight: 400;
	font-style: normal;
}

.empy-spay {
	/* background: #f9a303; */
}

.mission a {
	text-decoration: none;

}

.mission a h3,
.mission a p {
	color: #3a3a3a;
}

.about-block ul li {
	font-family: "Raleway", serif;
	font-optical-sizing: auto;
	font-style: normal;
	text-align: justify;
}

.navbar-text {
	padding: 5px;
}

.width-100 {
	width: 100%;
}

.genorocity-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	height: 160px;
	background-size: cover;
}

.eft-div {
	background: #0000001a;
	height: 100%;
	margin: auto;
	text-align: center;
	padding-top: 10%;
}

.eft-div p {
	display: none;
}

.eft-div p a {
	color: black;
	text-decoration: none;
}

.eft-div img {
	display: block;
	margin-left: auto;
	margin-right: auto;
	width: 50%;
	top: 21%;
	position: relative;
	border-radius: 30px;
	cursor: pointer;
	transition: transform .2s;
}

.news-row a {
	text-decoration: none;
}

.eft-div img:hover {
	transform: scale(1.2);
}

.nft-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	height: 160px;
	background-size: cover;
}

.axepay-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	height: 160px;
	background-size: cover;
}

.profilr-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
	height: 160px;
	background-size: cover;
}

.mtickets-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
	height: 160px;
	background-size: cover;
}

.articul-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
	height: 160px;
	background-size: cover;
}

.eschool-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
	height: 160px;
	background-size: cover;
}

.doc_vid-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
	height: 160px;
	background-size: cover;
}

.abotslife-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
	height: 160px;
	background-size: cover;
}

.ijobs-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
	height: 160px;
	background-size: cover;
}

.distributer-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
	height: 160px;
	background-size: cover;
}

.originatorx-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
	height: 160px;
	background-size: cover;
}

.guru-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
	height: 160px;
	background-size: cover;
}

.continue2eat-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
	height: 160px;
	background-size: cover;
}

.games-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
	height: 160px;
	background-size: cover;
}

.atelier-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
	height: 160px;
	background-size: cover;
}

.phaces-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
	height: 160px;
	background-size: cover;
}

.redeembank-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
	height: 160px;
	background-size: cover;
}

.metarealm-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
	height: 160px;
	background-size: cover;
}

.onroute-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
	height: 160px;
	background-size: cover;
}

.mytravel-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
	height: 160px;
	background-size: cover;
}

.check21saas-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
	height: 160px;
	background-size: cover;
}

.menuevents-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
	height: 160px;
	background-size: cover;
}

.flexiibility-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
	height: 160px;
	background-size: cover;
}

.emphasispay-div {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
	height: 160px;
	background-size: cover;
}

.log-area {
	margin: 0px;
}

.otc-sec img {
	height: 40px;
}

.otc-sec {
	display: flex;
}

.eft-div:hover p {
	display: block;
}

.eft-div:hover {
	background: #807d7dad;
}

.logo-row {
	display: flex;
}

.flip-box {
	background-color: transparent;
	width: 200px;
	height: 140px;
	border: 1px solid #f1f1f1;
	perspective: 1000px;
	cursor: pointer;
	margin: 5px;
}

.flip-box-inner {
	position: relative;
	width: 100%;
	height: 100%;
	text-align: center;
	transition: transform 0.8s;
	transform-style: preserve-3d;
}

.flip-box-back a {
	text-decoration: none;
	color: white;
}

.flip-box:hover .flip-box-inner {
	transform: rotateY(180deg);
}

.flip-box-front,
.flip-box-back {
	position: absolute;
	width: 100%;
	height: 100%;
	backface-visibility: hidden;
}

.flip-box-front {
	background-color: #ffffff;
	color: rgb(214, 212, 212);
	padding: 5px;
}

.flip-box-front img {
	width: 100%;
}

.flip-box-back {
	background-color: #555;
	color: white;
	transform: rotateY(180deg);
	padding-top: 5px;
}

.img1 {
	height: 105px;
}

.img4 {
	margin-top: 15%;
}

.sosl {
	text-align: center;
	padding: 10px;
}

.sosl img {
	height: 50px !important;
}

.main-img {
	height: 50px;
}

.our-team img {
	height: 150px;
}

.border-right-10 {
	border-right: 1px solid #7c7c7c;
}

.rcb-chat-footer-container {
	opacity: 0;
}

.fixed {
	position: fixed;
	bottom: 0px;
	right: 0px;
	z-index: 9999;
}

.flor-right {
	float: right;
}

.text-justify {
	text-align: justify;
}

.text-team {
	font-family: "Quicksand", serif;
	font-optical-sizing: auto;
	font-style: normal;
	text-align: justify;
}

.our-team h3 {
	font-family: "Quicksand", serif;
	font-optical-sizing: auto;
	font-weight: 700;
	font-style: normal;
}

.contact-form input {
	height: 50px;
	border: 2px solid #54505096;
}

.contact-form input,
.contact-form textarea {
	border: 2px solid #54505096;
}

.contact-info svg {
	font-size: 25px;
	color: #ffa800;
}

.bagg {
	height: 50px;
	width: 50px;
	background: #afacacba;
	text-align: center;
	border-radius: 50%;
	padding-top: 18%;
	font-size: 24px;
	color: #3c3c3c;
	margin-top: 81%;
}

.primaryc {
	color: #d08900;
}

.color-light {
	color: #697686;
}

.black-bg {
	background: black;
}

.pt-16 {
	padding-top: 1px !important;
}

.dropdown-menu a {
	color: black !important;
}

.min-details {
	text-align: center;
	font-size: 15px;
	font-size: 18px;
	font-weight: 400;
}

.coin-list,
.coin-list1 {
	display: flex;
	/* flex-direction: row;
    justify-content: space-between; */
}

.coin-list1 img {
	height: 38px;
	width: 100px;
	margin: 23px;
}

.imgg-row img {
	height: 64px;
}

.imgg-row .col-sm-4 div {
	border: 1px solid #737373;
	width: 100%;
	height: 100px;
	text-align: center;
	padding-top: 15px;
}

.coin-list img {
	/* height: 38px;
    margin: 23px; */
	height: 64px;
}

.img-vec {
	height: 100px;
}

.token h4 {
	font-size: 33px;
}

.serv .main-div {
	border-bottom: 2px solid #f9a303;
	height: 100%;
	background-image: linear-gradient(to top, #f9a303 50%, transparent 50%);
	background-size: 100% 200%;
	background-position: top;
	transition: background-position 0.5s ease-in-out;
	cursor: pointer;
	padding: 5px;
}

.serv .main-div:hover {
	background-position: bottom;
}

.serv .main-div:hover p {
	color: white;
}

.padin-footer-menu {
	/* padding-top: 83px; */
}

.text-team {
	font-size: 19px;
	font-weight: 500;
}

@media only screen and (max-width: 600px) {
	.padin-footer-menu {
		padding-top: 0px !important;
	}

	.footer1 h3,
	.center-phone {
		text-align: center;
	}

	.link_button {
		margin: auto;
		margin-top: 15px;
	}

	.coin-list1,
	.coin-list {
		overflow-x: scroll;
	}

	.pt20m {
		padding-top: 21px;
	}

	.log-text {
		display: block !important;
		top: 0px !important;
	}

	.right-menu {
		padding-bottom: 7px;
	}

	.blk-menu ul {
		margin-top: 0px !important;
	}

	.menu {
		float: left !important;
	}
}

.log-area svg,
.bg-nav svg {
	font-size: 28px;
}

.img-row .col-sm-2 img {
	height: 100%;
	width: 100%;
}

.img-row .col-sm-2 {
	/* height: 50px; */
	text-align: center;
	/* margin: 4px; */
	padding: 7px;
}

.img-row .col-sm-2 div {
	border: 1px solid #737373;
	width: 100%;
	height: 100px;
}

.log-text {
	display: inline;
	position: relative;
	top: 20px;
	padding-left: 10px;
}

.log-text a {
	text-decoration: none;
	color: white;
}

.maximg-hht {
	height: 47px;
}

.prod-row .col-sm-3 {
	cursor: pointer;
}

.he-47 {
	height: 39px;
}

.eft-div_0 {
	background: #373737;
	background: #373737;
	padding-left: 8px;
	height: 100px;
	padding-top: 6px;
}

.eft-div_0 a {
	text-decoration: none;
	color: white;
}

.serv a {
	text-decoration: none;
	color: black;
}

.product-div {
	background: black;
	padding: 5px;
}

.product-div h3 {
	font-size: 17px;
	color: white;
}

.min-box {
	text-align: center;
	color: white;
	border: 1px solid white;
	padding-bottom: 8px;
	border-radius: 7px;
}

.hight-50 {
	height: 50px;
}

.product-div .col-sm-4 .row {
	margin: 0px !important;
}

.granular-img {
	height: 53px;
	border: 1px solid white;
	padding: 6px 50px;
	border-radius: 7px;
}

.right-box {
	color: white;
	text-align: center;
	border: 1px solid white;
	height: 50px;
	border-radius: 7px;
	padding-top: 8px;

}

.pt-10 {
	padding-top: 10px;
}

.hight-43 {
	height: 43px;
}

.genoro-box,
.mtickets-box {
	border: 1px solid white;
	border-radius: 7px;
	text-align: center;
	padding-bottom: 11px;
	margin-bottom: 8px;
}

.genoro-box img {
	height: 74px;
}

.width-88 {
	width: 88%;
}

.controller-div {
	border: 3px dotted #a52121;
	padding: 9px 0px
}

.text-ctrl {
	padding: 5px;
	margin: 0px;
	text-align: center;
	color: white;
	position: relative;
	top: 21px;
	font-weight: bold;
	border: 1px solid white;
	border-radius: 7px;
	display: inline;
	background: black;
}

.f-50 {
	font-size: 50px;
}

.pos span {
	padding: 2px 5px;
	margin: 2px 3px;
	border: 1px solid;
	border-radius: 9px;
}

.main-box {
	display: flex;
	border: 2px dotted #ac2626;
	padding: 6px;
}

.main-box div img {
	width: 80%;

}

.width-80 {
	width: 80px !important;
}

.bg-product {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
	height: 700px;
	background-repeat: no-repeat;
	background-size: cover;
}

.img-qr-code {
	height: 126px;
}

.b-use-case p {
	margin-bottom: 0px;
	color: #5effe8;
	font-family: "Poppins", serif;
	font-weight: 400;
	font-style: normal;
}

.b-use-case h3 {
	border-bottom: 2px solid #f95c00;
	font-size: 18px;
}

.b-use-case h3,
.b-use-case li {
	color: white;
	font-family: "Poppins", serif;
	font-weight: 400;
	font-style: normal;
}

.pl-5 {
	padding-left: 30px;
}

.left-mnu,
.ps-sidebar-container {
	height: 800px;
	background: #3f51b5;
}

.row0 {
	display: flex;
}

.left-mnu ul li {
	border-bottom: 1px solid #b4b4b6b0;
}

.left-mnu ul li a {
	color: white !important;

	font-family: "DM Sans", serif;
	font-optical-sizing: auto;
	/* font-weight: <weight>; */
	font-style: normal;
}

.border-right-1 {
	text-align: center;
	border-right: 1px solid #6b6b6b;
	padding: 10px;
}

.border-right-1 svg {
	font-size: 50px;
}

.content-areas {
	flex: 5 1;
}

.navbar-menu {
	height: 69px;
	background-color: #607D8B;
	box-shadow: 1px 1px 8px 2px #3a3a3a;
	text-align: right;
	padding: 14px;
}

.navbar-menu svg {
	font-size: 25px;
	color: white;
}

.mrhgn {
	margin: 39px 10px;
	border: 1px solid #cecece;
	padding: 10px;
	box-shadow: 1px 1px 9px #a3a3a3;
}

.mrhgn h5 {
	text-align: center;
}

.left-mnu ul li:hover a,
.left-mnu ul li:hover a span,
.left-mnu ul li ul li a,
.left-mnu ul li ul li a span {
	color: black !important;
}

.b-use-case .col-sm-4 {
	margin-bottom: 20px;
}

.chatbot-all {
	position: fixed;
	bottom: 0px;
	right: 16px;
	;
}

.ctabot-form-box {
	height: 100vh;
	width: 455px;
	border: 1px solid #cfcece;
	box-shadow: -3px 4px 6px #4c4c4c;
	z-index: 99999999;
	position: relative;
	border-radius: 5px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

.chatbot-logo-box {
	text-align: center;
	padding-top: 10px;
}

.ask-logo {
	height: 70px;
	cursor: pointer;
}

.header-window button {
	border: 0;
	background: transparent;
}

.header-window {
	background: rgb(0, 0, 0);
	background: linear-gradient(180deg, rgba(0, 0, 0, 1) 94%, rgba(112, 112, 112, 0.0032387955182072714) 100%);
	/* background-image: linear-gradient(279deg, #d9000057, #df0000); */
	display: flex;
	justify-content: space-between;
	height: 60px;
}

.chatbot-contern-area {
	height: 83vh;
}

.header-logo {
	height: 57px;
	margin: 3px;
}

.button-all button {
	padding: 5px;
	font-size: 15px;
	color: white;
	margin: 1px 3px;
}

.ask-me {
	background: rgb(0, 212, 255);
	background: linear-gradient(90deg, rgba(0, 212, 255, 1) 0%, rgba(0, 8, 36, 0.6362920168067228) 100%);
}

.feed-back {
	background: rgb(0, 255, 81);
	background: linear-gradient(90deg, rgba(0, 255, 81, 1) 0%, rgba(0, 36, 14, 0.6362920168067228) 100%);
}

.contact-us {
	background: rgb(164, 255, 0);
	background: linear-gradient(90deg, rgba(164, 255, 0, 1) 0%, rgba(0, 36, 14, 0.6362920168067228) 100%);
}

.message-great {
	font-size: 16px;

}

.mlr-5 {
	margin: 0px 5px;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AASA;CACC,SAAS;CACT;;YAEW;CACX,mCAAmC;CACnC,kCAAkC;CAClC,kBAAkB;AACnB;;AAEA;CACC;WACU;AACX;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mDAAqC;CACrC,sBAAsB;AACvB;;AAEA;CACC,2BAA2B;CAC3B,mBAAmB;CACnB,yBAAyB;CACzB,iBAAiB;CACjB,wBAAwB;CACxB,sBAAsB;AACvB;;AAEA;;CAEC,sBAAsB;CACtB,0BAA0B;CAC1B,cAAc;CACd,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,yCAAyC;AAC1C;;AAEA;CACC,sBAAsB;CACtB,yCAAyC;AAC1C;;AAEA;;CAEC,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,cAAc;CACd,WAAW;CACX,YAAY;CACZ,UAAU;CACV,6BAA6B;CAC7B,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,kBAAkB;CAClB,UAAU;CACV,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;;CAEC,iGAAiG;CACjG;EACC,aAAa;CACd;;CAEA;;EAEC,UAAU;CACX;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,2BAA2B;EAC3B,0BAA0B;CAC3B;AACD;;AAEA;CACC,YAAY;AACb;;;AAGA;CACC,eAAe;AAChB;;AAEA;CACC,+BAA+B;CAC/B,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;CACd,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,sBAAsB;CACtB,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CAKT,2BAA2B;AAC5B;;AAEA;CACC,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CAKT,2BAA2B;CAC3B,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;CACpB,kCAAkC;AACnC;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,+BAA+B;CAC/B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,iBAAiB;CACjB,+BAA+B;CAC/B,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,yBAAyB;CACzB,UAAU;CAKV,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,MAAM;CACN,SAAS;CAKT,2BAA2B;CAC3B,UAAU;CACV,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,UAAU;CAKV,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CAKf,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;iCAEiC;;AAEjC;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mDAAsC;AACvC;;AAEA;CACC;;;;gBAIe;AAChB;;AAEA;CACC,+BAA+B;CAC/B,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;CACd,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CAIrB,mBAAmB;CACnB,gBAAgB;CAChB,gDAAgD;CAChD,yBAAyB;CACzB,YAAY;CACZ,mDAAmD;CACnD,iCAAiC;CACjC,4BAA4B;CAC5B,yBAAyB;CACzB,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC;iBACgB;;AAEjB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;;iCAEiC;;AAEjC;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;AACV;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,2CAA2C;CAC3C,kBAAkB;CAClB,aAAa;CACb,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,YAAY;CACZ,aAAa;CACb,eAAe;CACf,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,YAAY;CAKZ,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,WAAW;AACZ;;AAEA;;CAEC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;CACzB,2BAA2B;CAC3B,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,mDAAsC;AACvC;;AAEA;CACC,2BAA2B;CAC3B,yBAAyB;CACzB,2BAA2B;CAC3B,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;;AAEtB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mDAAwD;CACxD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mDAAiD;CACjD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mDAAoD;CACpD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mDAAsD;CACtD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mDAAsD;CACtD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mDAAqD;CACrD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mDAAqD;CACrD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mDAAqD;CACrD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAuD;CACvD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAmD;CACnD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAyD;CACzD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAyD;CACzD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAkD;CAClD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAA0D;CAC1D,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAmD;CACnD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAqD;CACrD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAoD;CACpD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAwD;CACxD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAuD;CACvD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAqD;CACrD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAsD;CACtD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAyD;CACzD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAqD;CACrD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAuD;CACvD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,oDAAsD;CACtD,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,6BAA6B;CAC7B,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,0BAA0B;CAC1B,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,YAAY;CAEZ,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,eAAe;CACf,WAAW;CACX,UAAU;CACV,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;CAC/B,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;CAC/B,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;;CAEC,aAAa;CACb;qCACoC;AACrC;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC;mBACkB;CAClB,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,uEAAuE;CACvE,0BAA0B;CAC1B,wBAAwB;CACxB,gDAAgD;CAChD,eAAe;CACf,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;;EAEC,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,gBAAgB;CACjB;;CAEA;;EAEC,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,yBAAyB;EACzB,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,sBAAsB;CACvB;AACD;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,aAAa;AACd;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,iBAAiB;CACjB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;;AAEjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;;CAEC,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,0BAA0B;CAC1B,YAAY;AACb;;AAEA;CACC,UAAU;;AAEX;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oDAAqC;CACrC,aAAa;CACb,4BAA4B;CAC5B,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,eAAe;AAChB;;AAEA;;CAEC,YAAY;CACZ,6BAA6B;CAC7B,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,uBAAuB;;CAEvB,6BAA6B;CAC7B,yBAAyB;CACzB,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,+BAA+B;CAC/B,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,SAAO;AACR;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,mCAAmC;CACnC,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;;CAIC,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,WAAW;;AAEZ;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,yBAAyB;CACzB,gCAAgC;CAChC,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,oDAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,SAAS;CACT,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;CACxB,0GAA0G;CAC1G,mEAAmE;CACnE,aAAa;CACb,8BAA8B;CAC9B,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,oGAAoG;AACrG;;AAEA;CACC,2BAA2B;CAC3B,oGAAoG;AACrG;;AAEA;CACC,4BAA4B;CAC5B,qGAAqG;AACtG;;AAEA;CACC,eAAe;;AAEhB;;AAEA;CACC,eAAe;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&family=Sora:wght@100..800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n\n\nbody {\n\tmargin: 0;\n\tfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n\t\t'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n\t\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\toverflow-x: hidden;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n\t\tmonospace;\n}\n\n.blk-menu {\n\tpadding: 5px 2px;\n\tbackground-color: black;\n\tpadding-left: 6%;\n\tpadding-right: 6%;\n}\n\n.blk-menu ul {\n\tpadding: 0px;\n\tlist-style: none;\n\tmargin-top: 23px;\n}\n\n.menu {\n\tpadding: 0px;\n\tlist-style: none;\n\tfloat: right;\n\tmargin-top: 3%;\n}\n\n.menu li {\n\tfloat: left;\n}\n\n.menu li a {\n\ttext-decoration: none;\n\tpadding: 10px;\n\tcolor: #fff;\n}\n\n.border-right1 {\n\tborder-right: 1px solid #ffc107;\n}\n\n.yellow-text {\n\tcolor: #ffc107 !important;\n}\n\n.bg-nav {\n\tbackground-color: #ffa800;\n}\n\n.bg-nav ul li a {\n\t/* padding: 20px; */\n\tcolor: white;\n\tfont-weight: 500;\n\ttext-decoration: none;\n}\n\n.bg-nav ul li {\n\tpadding: 20px;\n}\n\n.slide {\n\theight: 500px;\n\tbackground: url('./img/bg_slide.png');\n\tbackground-size: cover;\n}\n\n.slick-slider {\n\t-webkit-touch-callout: none;\n\ttouch-action: pan-y;\n\t-webkit-user-select: none;\n\tuser-select: none;\n\t-khtml-user-select: none;\n\tmargin: 30px auto 50px;\n}\n\n.slick-next:before,\n.slick-prev:before {\n\tcolor: #fff !important;\n\tfont-size: 32px !important;\n\tline-height: 1;\n\topacity: .75 !important;\n\tcolor: #ffa800 !important;\n}\n\n.slick-prev {\n\tleft: 11px !important;\n\tz-index: 99999999999999999999999999999999;\n}\n\n.slick-next {\n\tright: 11px !important;\n\tz-index: 99999999999999999999999999999999;\n}\n\n.slick-prev,\n.slick-next {\n\tfont-size: 0;\n\tline-height: 0;\n\tposition: absolute;\n\ttop: 50%;\n\tdisplay: block;\n\twidth: 20px;\n\theight: 20px;\n\tpadding: 0;\n\ttransform: translate(0, -50%);\n\tcursor: pointer;\n\tcolor: transparent;\n\tborder: none;\n\toutline: none;\n\tbackground: transparent;\n}\n\n.slick-slider {\n\tmargin: 0px !important;\n}\n\n.center {\n\tmargin: auto;\n\ttext-align: center;\n\ttop: 25%;\n\tposition: relative;\n\twidth: 50%;\n\tbackground: #00000061;\n\tpadding: 30px;\n}\n\n.bg-yellow {\n\tbackground: #ffc107 !important;\n}\n\n.intro_image {\n\tmax-width: 100%;\n\t/* height: 394px; */\n\tmargin-right: 10px;\n}\n\n.intro {\n\tpadding-top: 110px;\n\tpadding-bottom: 110px;\n\tbackground: #f5f9fa;\n}\n\n@media (min-width:641px) {\n\n\t/* portrait tablets, portrait iPad, e-readers (Nook/Kindle), landscape 800x480 phones (Android) */\n\t.bg-nav ul li {\n\t\tpadding: 17px;\n\t}\n\n\t.min-box img,\n\t.genoro-box img {\n\t\twidth: 80%;\n\t}\n\n\t.genoro-box img {\n\t\theight: auto !important;\n\t}\n\n\t.min-box {\n\t\tfont-size: 10px;\n\t}\n\n\t.granular-img {\n\t\twidth: 100%;\n\t}\n\n\t.pos span {\n\t\tpadding: 2px 3px !important;\n\t\tmargin: 2px 3px !important;\n\t}\n}\n\n.right-box {\n\theight: auto;\n}\n\n\n.intro_image img {\n\tmax-width: 100%;\n}\n\n.intro_title {\n\tfont-family: 'gill', sans-serif;\n\tcolor: #212121;\n\tmargin-top: -1px;\n}\n\n.intro_subtitle {\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\tletter-spacing: 0.2em;\n\tcolor: #a5a5a5;\n\tpadding-left: 6px;\n\tpadding-top: 30px;\n}\n\n.intro_subtitle::after {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 5px;\n\twidth: 68px;\n\theight: 3px;\n\tbackground: #ffa800;\n\tcontent: '';\n}\n\n.intro_text {\n\tmargin-top: 32px;\n}\n\n.intro_text p:last-of-type {\n\tmargin-bottom: 0;\n}\n\n.intro_button {\n\tmargin-top: 39px;\n}\n\n.home_slider_container {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.home_slider {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.slider_background {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: center center;\n}\n\n.home_slider .owl-dots {\n\tposition: absolute;\n\tbottom: 29px;\n\tleft: 50%;\n\t-webkit-transform: translateX(-50%);\n\t-moz-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\t-o-transform: translateX(-50%);\n\ttransform: translateX(-50%);\n}\n\n.home_slider .owl-dots .owl-dot span {\n\twidth: 8px;\n\theight: 8px;\n\tbackground: #d2d2d2;\n\tmargin-top: 5px;\n\tmargin-right: 6px;\n\tmargin-bottom: 5px;\n\tmargin-left: 6px;\n}\n\n.home_slider .owl-dots .owl-dot.active span {\n\tbackground: #bda994;\n}\n\n.home_slider_content {\n\tposition: absolute;\n\ttop: 35%;\n\tleft: 50%;\n\t-webkit-transform: translateX(-50%);\n\t-moz-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\t-o-transform: translateX(-50%);\n\ttransform: translateX(-50%);\n\twidth: 776px;\n\tpadding-left: 25px;\n\tpadding-right: 25px;\n\tpadding-top: 74px;\n\tpadding-bottom: 55px;\n\tbackground: rgba(17, 16, 14, 0.83);\n}\n\n.home_slider_content h1 {\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 72px;\n\tline-height: 1.1;\n\tcolor: #FFFFFF;\n}\n\n.home_slider_text {\n\twidth: 72%;\n\tmargin: 0 auto;\n\tmargin-top: 15px;\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 18px;\n\tcolor: #FFFFFF;\n}\n\n.link_button {\n\twidth: 174px;\n\theight: 59px;\n\tbackground: #ffa800;\n\ttext-align: center;\n}\n\n.link_button a {\n\tdisplay: block;\n\tposition: relative;\n\tline-height: 59px;\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: #FFFFFF;\n\ttext-transform: uppercase;\n\tz-index: 1;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.home_slider_button {\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.link_button a::after {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 50%;\n\t-webkit-transform: translateX(-50%);\n\t-moz-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\t-o-transform: translateX(-50%);\n\ttransform: translateX(-50%);\n\twidth: 50%;\n\theight: 100%;\n\tbackground: #FFFFFF;\n\tcontent: '';\n\topacity: 0;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tz-index: -1;\n}\n\n.link_button:hover a::after {\n\twidth: 100%;\n\topacity: 1;\n}\n\n.link_button:hover a {\n\tcolor: #ffa800;\n}\n\n.home_slider_nav {\n\tposition: absolute;\n\ttop: 56.32%;\n\twidth: 46px;\n\theight: 46px;\n\tborder-radius: 50%;\n\tbackground: #939393;\n\tcursor: pointer;\n\t-webkit-transition: all 200ms ease;\n\t-moz-transition: all 200ms ease;\n\t-ms-transition: all 200ms ease;\n\t-o-transition: all 200ms ease;\n\ttransition: all 200ms ease;\n\tz-index: 10;\n}\n\n.home_slider_prev {\n\tleft: 177px;\n}\n\n.home_slider_next {\n\tright: 177px;\n}\n\n.home_slider_nav:hover {\n\tbackground: #ffa800;\n}\n\n/*********************************\n8. Converter\n*********************************/\n\n.converter {\n\tpadding-top: 130px;\n\tpadding-bottom: 138px;\n\tbackground: url('./img/converter.jpg');\n}\n\n.converter_background {\n\t/* position: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%; */\n}\n\n.converter_title {\n\tfont-family: 'gill', sans-serif;\n\tcolor: #FFFFFF;\n\tmargin-top: -1px;\n}\n\n.converter_subtitle {\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n\tletter-spacing: 0.2em;\n\tcolor: #a5a5a5;\n\tpadding-left: 2px;\n\tpadding-top: 30px;\n}\n\n.converter_subtitle::after {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 5px;\n\twidth: 68px;\n\theight: 3px;\n\tbackground: #ffa800;\n\tcontent: '';\n}\n\n.converter_text {\n\tmargin-top: 32px;\n}\n\n.converter_text p {\n\tcolor: #FFFFFF;\n}\n\n.converter_text p:last-of-type {\n\tmargin-bottom: 0;\n}\n\n.converter_container {\n\tpadding-top: 182px;\n}\n\n.converter_container form:last-of-type {\n\tmargin-top: 19px;\n}\n\n.converter_input {\n\tdisplay: inline-block;\n\twidth: 84px;\n\theight: 52px;\n\tbackground: transparent;\n\tcolor: #FFFFFF;\n\ttext-align: center;\n\tfont-size: 18px;\n\tfont-weight: 600;\n\toutline: none;\n\tvertical-align: top;\n\tmargin-right: 10px;\n}\n\n.converter_input_value {\n\tborder: solid 2px #ffa800;\n}\n\n.dropdown_converter {\n\tdisplay: inline-block;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\t-ms-appearance: none;\n\t-o-appearance: none;\n\tappearance: none;\n\t-webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n\t-webkit-user-select: none;\n\twidth: 134px;\n\t/* background-image: url(../images/dropdown.png); */\n\tbackground-position: center right;\n\tbackground-repeat: no-repeat;\n\tborder: solid 2px #c6b5b7;\n\tpadding-left: 20px;\n\ttext-transform: uppercase;\n\tvertical-align: top;\n\tcursor: pointer;\n}\n\n.dropdown_converter:hover {\n\tborder: solid 2px #ffa800;\n}\n\n.converter_result {\n\tborder: solid 2px #c6b5b7;\n\twidth: 116px;\n}\n\n.dropdown_converter option {\n\tcolor: #11100e;\n}\n\n.converter_input::-webkit-input-placeholder {\n\tfont-size: 18px !important;\n\tfont-weight: 600 !important;\n\tcolor: #FFFFFF !important;\n}\n\n.converter_input:-moz-placeholder {\n\tfont-size: 18px !important;\n\tfont-weight: 600 !important;\n\tcolor: #FFFFFF !important;\n}\n\n.converter_input::-moz-placeholder {\n\tfont-size: 18px !important;\n\tfont-weight: 600 !important;\n\tcolor: #FFFFFF !important;\n}\n\n.converter_input:-ms-input-placeholder {\n\tfont-size: 18px !important;\n\tfont-weight: 600 !important;\n\tcolor: #FFFFFF !important;\n}\n\n.converter_input::input-placeholder {\n\tfont-size: 18px !important;\n\tfont-weight: 600 !important;\n\tcolor: #FFFFFF !important;\n}\n\n.eq {\n\tdisplay: inline-block;\n\twidth: 95px;\n\theight: 52px;\n\tvertical-align: top;\n\tline-height: 48px;\n\tfont-size: 30px;\n\tfont-weight: 600;\n\tcolor: #FFFFFF;\n\ttext-align: center;\n\tmargin-right: 10px;\n}\n\n.bg-black1 {\n\t/* background: black;\n\tpadding: 10px; */\n\n}\n\n.footer1 h3 {\n\tfont-size: 16px;\n\tcolor: white;\n}\n\n/*********************************\n11. Footer\n*********************************/\n\n.footer {\n\tpadding-top: 20px;\n\tbackground: #15191f;\n}\n\n.footer_logo {\n\tposition: absolute;\n\ttop: -18px;\n\tleft: 0px;\n}\n\n.footer_about_text {\n\tcolor: #c2cbd7;\n\tline-height: 2.14;\n\tpadding-top: 86px;\n}\n\n.footer_about p:last-of-type {\n\tmargin-bottom: 0;\n}\n\n.footer_title {\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 24px;\n\tcolor: #FFFFFF;\n}\n\n.footer_links ul {\n\tcolumns: 2;\n\t-webkit-columns: 2;\n\t-moz-columns: 2;\n\tmargin-top: 53px;\n}\n\n.footer_links ul li {\n\tmargin-bottom: 9px;\n}\n\n.footer_links ul li a {\n\tfont-size: 14px;\n\tcolor: #c2cbd7;\n\t-webkit-transition: all 200ms ease;\n\t-moz-transition: all 200ms ease;\n\t-ms-transition: all 200ms ease;\n\t-o-transition: all 200ms ease;\n\ttransition: all 200ms ease;\n}\n\n.footer_links ul li a:hover {\n\tcolor: #ffa800;\n}\n\n.footer_newsletter_form {\n\tdisplay: block;\n\tposition: relative;\n\tmargin-top: 20px;\n}\n\n.footer_newsletter_input {\n\twidth: 100%;\n\theight: 47px;\n\tbackground: transparent;\n\tborder: solid 2px rgba(224, 227, 228, 0.17);\n\tpadding-left: 26px;\n\toutline: none;\n\tcolor: #ffa800;\n\t-webkit-transition: all 200ms ease;\n\t-moz-transition: all 200ms ease;\n\t-ms-transition: all 200ms ease;\n\t-o-transition: all 200ms ease;\n\ttransition: all 200ms ease;\n}\n\n.footer_newsletter_input:focus {\n\tborder: solid 2px rgba(224, 227, 228, 0.34);\n}\n\n.footer_newsletter_button {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\twidth: 127px;\n\theight: 47px;\n\tbackground: #ffa800;\n\tborder: none;\n\toutline: none;\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n\tcolor: #FFFFFF;\n\tfont-weight: 600;\n\tcursor: pointer;\n}\n\n.footer_newsletter_input::-webkit-input-placeholder {\n\tfont-size: 11px !important;\n\tfont-style: italic;\n\tcolor: #c2cbd7 !important;\n}\n\n.footer_newsletter_input:-moz-placeholder {\n\tfont-size: 11px !important;\n\tfont-style: italic;\n\tcolor: #c2cbd7 !important;\n}\n\n.footer_newsletter_input::-moz-placeholder {\n\tfont-size: 11px !important;\n\tfont-style: italic;\n\tcolor: #c2cbd7 !important;\n}\n\n.footer_newsletter_input:-ms-input-placeholder {\n\tfont-size: 11px !important;\n\tfont-style: italic;\n\tcolor: #c2cbd7 !important;\n}\n\n.footer_newsletter_input::input-placeholder {\n\tfont-size: 11px !important;\n\tfont-style: italic;\n\tcolor: #c2cbd7 !important;\n}\n\n.footer_newsletter_text {\n\tfont-size: 11px;\n\tline-height: 2.18;\n\tcolor: #c2cbd7;\n\tfont-style: italic;\n\tmargin-top: 19px;\n\tpadding-left: 3px;\n}\n\n.footer_social {\n\tmargin-top: 33px;\n}\n\n.footer_social ul li {\n\tdisplay: inline-block;\n\tmargin-right: 10px;\n}\n\n.footer_social ul li a i {\n\tcolor: #FFFFFF;\n\tfont-size: 17px;\n\tpadding: 5px;\n\t-webkit-transition: all 200ms ease;\n\t-moz-transition: all 200ms ease;\n\t-ms-transition: all 200ms ease;\n\t-o-transition: all 200ms ease;\n\ttransition: all 200ms ease;\n}\n\n.footer_social ul li:hover a i {\n\tcolor: #ffa800;\n}\n\n.copyright {\n\twidth: 100%;\n\tmargin-top: 110px;\n\tbackground: #0d1016;\n}\n\n.copyright_content {\n\twidth: 100%;\n\theight: 70px;\n}\n\n.footer_nav {\n\twidth: 100%;\n\theight: 70px;\n\ttext-align: right;\n}\n\n.footer_nav ul li {\n\tdisplay: inline-block;\n\tmargin-right: 23px;\n}\n\n.footer_nav ul li:last-child {\n\tmargin-right: 0;\n}\n\n.footer_nav ul li a {\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 13px;\n\tcolor: #697686;\n\t-webkit-transition: all 200ms ease;\n\t-moz-transition: all 200ms ease;\n\t-ms-transition: all 200ms ease;\n\t-o-transition: all 200ms ease;\n\ttransition: all 200ms ease;\n}\n\n.footer_nav ul li a:hover {\n\tcolor: #ffa800;\n}\n\n.cr {\n\tfont-family: 'gill', sans-serif;\n\tfont-size: 13px;\n\tcolor: #697686;\n}\n\n.footer1 ul {\n\tlist-style: none;\n\tpadding: 0px;\n\tmargin: 0px;\n}\n\n.footer1 ul li a,\n.footer1 a {\n\ttext-decoration: none;\n\tcolor: #ffa800;\n}\n\n.social-menu li {\n\tfloat: left;\n}\n\n.social-menu li a {\n\tpadding: 5px;\n}\n\n.social-menu li a svg {\n\tfont-size: 24px;\n}\n\n.mission img {\n\theight: 200px;\n}\n\n.msh1 {\n\tfont-family: \"Poppins\", serif;\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n\n.text1 {\n\tfont-family: \"Raleway\", serif;\n\tfont-optical-sizing: auto;\n\t/* font-weight: <weight>; */\n\tfont-style: normal;\n\ttext-align: justify;\n}\n\n.bg-about {\n\tpadding-bottom: 10px;\n\tbackground: url('./img/converter.jpg');\n}\n\n.about-a h2 {\n\tfont-family: \"Rubik\", serif;\n\tfont-optical-sizing: auto;\n\t/* font-weight: <weight>; */\n\tfont-style: normal;\n\tfont-size: 50px;\n}\n\n.h2-f {\n\tfont-size: 25px;\n\tfont-family: \"Poppins\", serif;\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n\n.empy-spay {\n\t/* background: #f9a303; */\n}\n\n.mission a {\n\ttext-decoration: none;\n\n}\n\n.mission a h3,\n.mission a p {\n\tcolor: #3a3a3a;\n}\n\n.about-block ul li {\n\tfont-family: \"Raleway\", serif;\n\tfont-optical-sizing: auto;\n\tfont-style: normal;\n\ttext-align: justify;\n}\n\n.navbar-text {\n\tpadding: 5px;\n}\n\n.width-100 {\n\twidth: 100%;\n}\n\n.genorocity-div {\n\tbackground: url('../src/img/products/genorocity_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.eft-div {\n\tbackground: #0000001a;\n\theight: 100%;\n\tmargin: auto;\n\ttext-align: center;\n\tpadding-top: 10%;\n}\n\n.eft-div p {\n\tdisplay: none;\n}\n\n.eft-div p a {\n\tcolor: black;\n\ttext-decoration: none;\n}\n\n.eft-div img {\n\tdisplay: block;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\twidth: 50%;\n\ttop: 21%;\n\tposition: relative;\n\tborder-radius: 30px;\n\tcursor: pointer;\n\ttransition: transform .2s;\n}\n\n.news-row a {\n\ttext-decoration: none;\n}\n\n.eft-div img:hover {\n\ttransform: scale(1.2);\n}\n\n.nft-div {\n\tbackground: url('../src/img/products/nft_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.axepay-div {\n\tbackground: url('../src/img/products/axepay_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.profilr-div {\n\tbackground: url('../src/img/products/profiler_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.mtickets-div {\n\tbackground: url('../src/img/products/mtickets_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.articul-div {\n\tbackground: url('../src/img/products/articul_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.eschool-div {\n\tbackground: url('../src/img/products/eschool_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.doc_vid-div {\n\tbackground: url('../src/img/products/doc_div_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.abotslife-div {\n\tbackground: url('../src/img/products/abotslife_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.ijobs-div {\n\tbackground: url('../src/img/products/ijobs_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.distributer-div {\n\tbackground: url('../src/img/products/distributer_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.originatorx-div {\n\tbackground: url('../src/img/products/originatorx_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.guru-div {\n\tbackground: url('../src/img/products/guru_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.continue2eat-div {\n\tbackground: url('../src/img/products/continue2eat_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.games-div {\n\tbackground: url('../src/img/products/games_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.atelier-div {\n\tbackground: url('../src/img/products/atelier_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.phaces-div {\n\tbackground: url('../src/img/products/phaces_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.redeembank-div {\n\tbackground: url('../src/img/products/redeembank_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.metarealm-div {\n\tbackground: url('../src/img/products/metarealm_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.onroute-div {\n\tbackground: url('../src/img/products/onroute_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.mytravel-div {\n\tbackground: url('../src/img/products/mytravel_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.check21saas-div {\n\tbackground: url('../src/img/products/check21saas_bg.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.menuevents-div {\n\tbackground: url('../src/img/products/menu.event.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.flexiibility-div {\n\tbackground: url('../src/img/products/flexiibility.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.emphasispay-div {\n\tbackground: url('../src/img/products/emphasispay.png');\n\theight: 160px;\n\tbackground-size: cover;\n}\n\n.log-area {\n\tmargin: 0px;\n}\n\n.otc-sec img {\n\theight: 40px;\n}\n\n.otc-sec {\n\tdisplay: flex;\n}\n\n.eft-div:hover p {\n\tdisplay: block;\n}\n\n.eft-div:hover {\n\tbackground: #807d7dad;\n}\n\n.logo-row {\n\tdisplay: flex;\n}\n\n.flip-box {\n\tbackground-color: transparent;\n\twidth: 200px;\n\theight: 140px;\n\tborder: 1px solid #f1f1f1;\n\tperspective: 1000px;\n\tcursor: pointer;\n\tmargin: 5px;\n}\n\n.flip-box-inner {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n\ttransition: transform 0.8s;\n\ttransform-style: preserve-3d;\n}\n\n.flip-box-back a {\n\ttext-decoration: none;\n\tcolor: white;\n}\n\n.flip-box:hover .flip-box-inner {\n\ttransform: rotateY(180deg);\n}\n\n.flip-box-front,\n.flip-box-back {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\t-webkit-backface-visibility: hidden;\n\tbackface-visibility: hidden;\n}\n\n.flip-box-front {\n\tbackground-color: #ffffff;\n\tcolor: rgb(214, 212, 212);\n\tpadding: 5px;\n}\n\n.flip-box-front img {\n\twidth: 100%;\n}\n\n.flip-box-back {\n\tbackground-color: #555;\n\tcolor: white;\n\ttransform: rotateY(180deg);\n\tpadding-top: 5px;\n}\n\n.img1 {\n\theight: 105px;\n}\n\n.img4 {\n\tmargin-top: 15%;\n}\n\n.sosl {\n\ttext-align: center;\n\tpadding: 10px;\n}\n\n.sosl img {\n\theight: 50px !important;\n}\n\n.main-img {\n\theight: 50px;\n}\n\n.our-team img {\n\theight: 150px;\n}\n\n.border-right-10 {\n\tborder-right: 1px solid #7c7c7c;\n}\n\n.rcb-chat-footer-container {\n\topacity: 0;\n}\n\n.fixed {\n\tposition: fixed;\n\tbottom: 0px;\n\tright: 0px;\n\tz-index: 9999;\n}\n\n.flor-right {\n\tfloat: right;\n}\n\n.text-justify {\n\ttext-align: justify;\n}\n\n.text-team {\n\tfont-family: \"Quicksand\", serif;\n\tfont-optical-sizing: auto;\n\tfont-style: normal;\n\ttext-align: justify;\n}\n\n.our-team h3 {\n\tfont-family: \"Quicksand\", serif;\n\tfont-optical-sizing: auto;\n\tfont-weight: 700;\n\tfont-style: normal;\n}\n\n.contact-form input {\n\theight: 50px;\n\tborder: 2px solid #54505096;\n}\n\n.contact-form input,\n.contact-form textarea {\n\tborder: 2px solid #54505096;\n}\n\n.contact-info svg {\n\tfont-size: 25px;\n\tcolor: #ffa800;\n}\n\n.bagg {\n\theight: 50px;\n\twidth: 50px;\n\tbackground: #afacacba;\n\ttext-align: center;\n\tborder-radius: 50%;\n\tpadding-top: 18%;\n\tfont-size: 24px;\n\tcolor: #3c3c3c;\n\tmargin-top: 81%;\n}\n\n.primaryc {\n\tcolor: #d08900;\n}\n\n.color-light {\n\tcolor: #697686;\n}\n\n.black-bg {\n\tbackground: black;\n}\n\n.pt-16 {\n\tpadding-top: 1px !important;\n}\n\n.dropdown-menu a {\n\tcolor: black !important;\n}\n\n.min-details {\n\ttext-align: center;\n\tfont-size: 15px;\n\tfont-size: 18px;\n\tfont-weight: 400;\n}\n\n.coin-list,\n.coin-list1 {\n\tdisplay: flex;\n\t/* flex-direction: row;\n    justify-content: space-between; */\n}\n\n.coin-list1 img {\n\theight: 38px;\n\twidth: 100px;\n\tmargin: 23px;\n}\n\n.imgg-row img {\n\theight: 64px;\n}\n\n.imgg-row .col-sm-4 div {\n\tborder: 1px solid #737373;\n\twidth: 100%;\n\theight: 100px;\n\ttext-align: center;\n\tpadding-top: 15px;\n}\n\n.coin-list img {\n\t/* height: 38px;\n    margin: 23px; */\n\theight: 64px;\n}\n\n.img-vec {\n\theight: 100px;\n}\n\n.token h4 {\n\tfont-size: 33px;\n}\n\n.serv .main-div {\n\tborder-bottom: 2px solid #f9a303;\n\theight: 100%;\n\tbackground-image: linear-gradient(to top, #f9a303 50%, transparent 50%);\n\tbackground-size: 100% 200%;\n\tbackground-position: top;\n\ttransition: background-position 0.5s ease-in-out;\n\tcursor: pointer;\n\tpadding: 5px;\n}\n\n.serv .main-div:hover {\n\tbackground-position: bottom;\n}\n\n.serv .main-div:hover p {\n\tcolor: white;\n}\n\n.padin-footer-menu {\n\t/* padding-top: 83px; */\n}\n\n.text-team {\n\tfont-size: 19px;\n\tfont-weight: 500;\n}\n\n@media only screen and (max-width: 600px) {\n\t.padin-footer-menu {\n\t\tpadding-top: 0px !important;\n\t}\n\n\t.footer1 h3,\n\t.center-phone {\n\t\ttext-align: center;\n\t}\n\n\t.link_button {\n\t\tmargin: auto;\n\t\tmargin-top: 15px;\n\t}\n\n\t.coin-list1,\n\t.coin-list {\n\t\toverflow-x: scroll;\n\t}\n\n\t.pt20m {\n\t\tpadding-top: 21px;\n\t}\n\n\t.log-text {\n\t\tdisplay: block !important;\n\t\ttop: 0px !important;\n\t}\n\n\t.right-menu {\n\t\tpadding-bottom: 7px;\n\t}\n\n\t.blk-menu ul {\n\t\tmargin-top: 0px !important;\n\t}\n\n\t.menu {\n\t\tfloat: left !important;\n\t}\n}\n\n.log-area svg,\n.bg-nav svg {\n\tfont-size: 28px;\n}\n\n.img-row .col-sm-2 img {\n\theight: 100%;\n\twidth: 100%;\n}\n\n.img-row .col-sm-2 {\n\t/* height: 50px; */\n\ttext-align: center;\n\t/* margin: 4px; */\n\tpadding: 7px;\n}\n\n.img-row .col-sm-2 div {\n\tborder: 1px solid #737373;\n\twidth: 100%;\n\theight: 100px;\n}\n\n.log-text {\n\tdisplay: inline;\n\tposition: relative;\n\ttop: 20px;\n\tpadding-left: 10px;\n}\n\n.log-text a {\n\ttext-decoration: none;\n\tcolor: white;\n}\n\n.maximg-hht {\n\theight: 47px;\n}\n\n.prod-row .col-sm-3 {\n\tcursor: pointer;\n}\n\n.he-47 {\n\theight: 39px;\n}\n\n.eft-div_0 {\n\tbackground: #373737;\n\tbackground: #373737;\n\tpadding-left: 8px;\n\theight: 100px;\n\tpadding-top: 6px;\n}\n\n.eft-div_0 a {\n\ttext-decoration: none;\n\tcolor: white;\n}\n\n.serv a {\n\ttext-decoration: none;\n\tcolor: black;\n}\n\n.product-div {\n\tbackground: black;\n\tpadding: 5px;\n}\n\n.product-div h3 {\n\tfont-size: 17px;\n\tcolor: white;\n}\n\n.min-box {\n\ttext-align: center;\n\tcolor: white;\n\tborder: 1px solid white;\n\tpadding-bottom: 8px;\n\tborder-radius: 7px;\n}\n\n.hight-50 {\n\theight: 50px;\n}\n\n.product-div .col-sm-4 .row {\n\tmargin: 0px !important;\n}\n\n.granular-img {\n\theight: 53px;\n\tborder: 1px solid white;\n\tpadding: 6px 50px;\n\tborder-radius: 7px;\n}\n\n.right-box {\n\tcolor: white;\n\ttext-align: center;\n\tborder: 1px solid white;\n\theight: 50px;\n\tborder-radius: 7px;\n\tpadding-top: 8px;\n\n}\n\n.pt-10 {\n\tpadding-top: 10px;\n}\n\n.hight-43 {\n\theight: 43px;\n}\n\n.genoro-box,\n.mtickets-box {\n\tborder: 1px solid white;\n\tborder-radius: 7px;\n\ttext-align: center;\n\tpadding-bottom: 11px;\n\tmargin-bottom: 8px;\n}\n\n.genoro-box img {\n\theight: 74px;\n}\n\n.width-88 {\n\twidth: 88%;\n}\n\n.controller-div {\n\tborder: 3px dotted #a52121;\n\tpadding: 9px 0px\n}\n\n.text-ctrl {\n\tpadding: 5px;\n\tmargin: 0px;\n\ttext-align: center;\n\tcolor: white;\n\tposition: relative;\n\ttop: 21px;\n\tfont-weight: bold;\n\tborder: 1px solid white;\n\tborder-radius: 7px;\n\tdisplay: inline;\n\tbackground: black;\n}\n\n.f-50 {\n\tfont-size: 50px;\n}\n\n.pos span {\n\tpadding: 2px 5px;\n\tmargin: 2px 3px;\n\tborder: 1px solid;\n\tborder-radius: 9px;\n}\n\n.main-box {\n\tdisplay: flex;\n\tborder: 2px dotted #ac2626;\n\tpadding: 6px;\n}\n\n.main-box div img {\n\twidth: 80%;\n\n}\n\n.width-80 {\n\twidth: 80px !important;\n}\n\n.bg-product {\n\tbackground: url('./img/product.jpeg');\n\theight: 700px;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n}\n\n.img-qr-code {\n\theight: 126px;\n}\n\n.b-use-case p {\n\tmargin-bottom: 0px;\n\tcolor: #5effe8;\n\tfont-family: \"Poppins\", serif;\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n\n.b-use-case h3 {\n\tborder-bottom: 2px solid #f95c00;\n\tfont-size: 18px;\n}\n\n.b-use-case h3,\n.b-use-case li {\n\tcolor: white;\n\tfont-family: \"Poppins\", serif;\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n\n.pl-5 {\n\tpadding-left: 30px;\n}\n\n.left-mnu,\n.ps-sidebar-container {\n\theight: 800px;\n\tbackground: #3f51b5;\n}\n\n.row0 {\n\tdisplay: flex;\n}\n\n.left-mnu ul li {\n\tborder-bottom: 1px solid #b4b4b6b0;\n}\n\n.left-mnu ul li a {\n\tcolor: white !important;\n\n\tfont-family: \"DM Sans\", serif;\n\tfont-optical-sizing: auto;\n\t/* font-weight: <weight>; */\n\tfont-style: normal;\n}\n\n.border-right-1 {\n\ttext-align: center;\n\tborder-right: 1px solid #6b6b6b;\n\tpadding: 10px;\n}\n\n.border-right-1 svg {\n\tfont-size: 50px;\n}\n\n.content-areas {\n\tflex: 5;\n}\n\n.navbar-menu {\n\theight: 69px;\n\tbackground-color: #607D8B;\n\tbox-shadow: 1px 1px 8px 2px #3a3a3a;\n\ttext-align: right;\n\tpadding: 14px;\n}\n\n.navbar-menu svg {\n\tfont-size: 25px;\n\tcolor: white;\n}\n\n.mrhgn {\n\tmargin: 39px 10px;\n\tborder: 1px solid #cecece;\n\tpadding: 10px;\n\tbox-shadow: 1px 1px 9px #a3a3a3;\n}\n\n.mrhgn h5 {\n\ttext-align: center;\n}\n\n.left-mnu ul li:hover a,\n.left-mnu ul li:hover a span,\n.left-mnu ul li ul li a,\n.left-mnu ul li ul li a span {\n\tcolor: black !important;\n}\n\n.b-use-case .col-sm-4 {\n\tmargin-bottom: 20px;\n}\n\n.chatbot-all {\n\tposition: fixed;\n\tbottom: 0px;\n\tright: 16px;\n\t;\n}\n\n.ctabot-form-box {\n\theight: 100vh;\n\twidth: 455px;\n\tborder: 1px solid #cfcece;\n\tbox-shadow: -3px 4px 6px #4c4c4c;\n\tz-index: 99999999;\n\tposition: relative;\n\tborder-radius: 5px;\n\tbackground: url(./img/bg.jpg);\n}\n\n.chatbot-logo-box {\n\ttext-align: center;\n\tpadding-top: 10px;\n}\n\n.ask-logo {\n\theight: 70px;\n\tcursor: pointer;\n}\n\n.header-window button {\n\tborder: 0;\n\tbackground: transparent;\n}\n\n.header-window {\n\tbackground: rgb(0, 0, 0);\n\tbackground: linear-gradient(180deg, rgba(0, 0, 0, 1) 94%, rgba(112, 112, 112, 0.0032387955182072714) 100%);\n\t/* background-image: linear-gradient(279deg, #d9000057, #df0000); */\n\tdisplay: flex;\n\tjustify-content: space-between;\n\theight: 60px;\n}\n\n.chatbot-contern-area {\n\theight: 83vh;\n}\n\n.header-logo {\n\theight: 57px;\n\tmargin: 3px;\n}\n\n.button-all button {\n\tpadding: 5px;\n\tfont-size: 15px;\n\tcolor: white;\n\tmargin: 1px 3px;\n}\n\n.ask-me {\n\tbackground: rgb(0, 212, 255);\n\tbackground: linear-gradient(90deg, rgba(0, 212, 255, 1) 0%, rgba(0, 8, 36, 0.6362920168067228) 100%);\n}\n\n.feed-back {\n\tbackground: rgb(0, 255, 81);\n\tbackground: linear-gradient(90deg, rgba(0, 255, 81, 1) 0%, rgba(0, 36, 14, 0.6362920168067228) 100%);\n}\n\n.contact-us {\n\tbackground: rgb(164, 255, 0);\n\tbackground: linear-gradient(90deg, rgba(164, 255, 0, 1) 0%, rgba(0, 36, 14, 0.6362920168067228) 100%);\n}\n\n.message-great {\n\tfont-size: 16px;\n\n}\n\n.mlr-5 {\n\tmargin: 0px 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
